import React, { useCallback } from 'react'
import { IconButton, Menu } from './'
import PropTypes from 'prop-types'

/**
 * MenuButton implements a general menu which is attached to props.buttonIcon.
 *
 * @param {object} props see MenuButton.propTypes
 * @returns {MenuButton} - MenuButton component
 */
const MenuButton = props => {
  const transformOrigin = props.transformOrigin || { horizontal: 'right', vertical: 'top' }
  const anchorOrigin = props.anchorOrigin || { horizontal: 'center', vertical: 'bottom' }

  const onSelect = useCallback(value => {
    props.onSelect && props.onSelect(value)
  }, [props.rowdata])

  return (
    <>
      <Menu
        onClose={props.onClose}
        onSelect={onSelect}
        items={props.items}
        transformOrigin={transformOrigin}
        anchorOrigin={anchorOrigin}
        noTranslate={true}
        id='menu'
      >
        <IconButton id={props.id}>
          {props.buttonIcon}
        </IconButton>
      </Menu>
    </>
  )
}

MenuButton.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   * Icon to be used as the button for the menu.
   */
  buttonIcon: PropTypes.node.isRequired,
  /**
   * Items for the menu.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  /**
   * Function that is called when a menu item is selected.
   */ 
  onSelect: PropTypes.func,
  rowdata: PropTypes.object,
  /**
   * Function that is called when a menu is closed.
   */ 
  onClose: PropTypes.func,
  /**
  This is the point on the popover which will attach to the anchor's origin.
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']),
    vertical: PropTypes.oneOf(['bottom', 'center', 'top']),
  }),
  /**
  This is the point on the anchor where the popover's anchorEl will attach to.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']),
    vertical: PropTypes.oneOf(['bottom', 'center', 'top']),
  }),
  /**
   Prevents the language translation of the menu items.
   */
  // noTranslate: PropTypes.bool,
}

MenuButton.defaultProps = {
  noTranslate: false,
}

export default MenuButton